import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const ChatPage = lazyWithRetry(() => import("@/features/chat/pages/ChatPage").then((m) => ({ default: m.ChatPage })));
const WarningLinkPage = lazyWithRetry(() =>
  import("@/features/chat/pages/WarningLinkPage").then((m) => ({ default: m.WarningLinkPage })),
);

export const CHAT_PATH = "/chat";
export const WARNING_LINK_PATH = "/chat/warning-link";

const pollRoutes: RouteConfig[] = [
  {
    path: CHAT_PATH,
    element: <ChatPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: `${CHAT_PATH}/:roomId`,
    element: <ChatPage />,
    isProtected: true,
    useMainLayout: true,
  },
  {
    path: WARNING_LINK_PATH,
    element: <WarningLinkPage />,
    isProtected: true,
    useMainLayout: false,
  },
];

export default pollRoutes;
